import type { BoxProps } from '@chakra-ui/react';
import { Box, Text } from '@chakra-ui/react';

interface UnreadBadgeProps extends BoxProps {
  count: number;
  mutedCount: number;
  maxCount?: number;
}

export function UnreadBadge({ count, mutedCount, maxCount = 99, ...props }: UnreadBadgeProps) {
  const count_ = useMemo(() => {
    return count || mutedCount || 0;
  }, [count, mutedCount]);

  if (count_ === 0) return null;

  return (
    <Box
      h="18px"
      minW="18px"
      lineHeight="18px"
      px="1"
      bg={count ? 'red' : 'grey.88'}
      color="white"
      textAlign="center"
      rounded="full"
      {...props}
    >
      <Text color="white" fontSize="12px" fontWeight="semibold" lineHeight="normal">
        {maxCount && count_ > maxCount ? `${maxCount}+` : count_}
      </Text>
    </Box>
  );
}
